import createChangeCartItemsThunk from '../helpers/createChangeCartItemsThunk';
import remove from '../content/changesets/remove';

export default createChangeCartItemsThunk('session/removeCartItem', remove);
